import posthog from 'posthog-js'

const POSTHOG_KEY = import.meta.env.VITE_POSTHOG_KEY || 'phc_rLczdbAiAbMoFRd83rwsdkxshZy7EEGnhCWEYLCNmycf'
const POSTHOG_HOST = 'https://us.i.posthog.com'

export function initAnalytics() {
  try {
    posthog.init(POSTHOG_KEY, {
      api_host: POSTHOG_HOST,
      capture_pageview: true,
      capture_pageleave: true,
      autocapture: false,
      // The marketing site is on www.socialbrewapp.com and this app is on the
      // bare socialbrewapp.com. localStorage is per-origin, so on its own it
      // gives a visitor arriving from marketing a brand-new anonymous id and
      // the journey looks like two unrelated people. The cookie half is shared
      // across .socialbrewapp.com, which lets the two halves stitch together.
      persistence: 'localStorage+cookie',
      cross_subdomain_cookie: true,
    })
  } catch { /* silently skip if CSP blocks eval */ }
}

export function identifyUser(userId: string, properties?: Record<string, any>) {
  try { posthog.identify(userId, properties) } catch { /* noop */ }
}

export function trackEvent(event: string, properties?: Record<string, any>) {
  try { posthog.capture(event, properties) } catch { /* noop */ }
}

export function resetUser() {
  try { posthog.reset() } catch { /* noop */ }
}
